import { createContext, Context, Dispatch, SetStateAction } from 'react';
import { SnackBarProperties } from '../Constants/ObjectDefinitions.js';

export const SnackBarDuration = 5000;

/**
 * @type {Context<SnackBarProperties>}
 */
export const SnackBarContext = createContext(undefined);

/**
 * @type {Context<Dispatch<SetStateAction<SnackBarProperties>>>}
 */
export const UpdateSnackBarContext = createContext(({ icon, body }) => ({
  icon,
  body,
}));
